import React, { Component } from "react";
import "../../src/styles/layout/header.scss";
import { Navbar, Nav, NavDropdown, Badge, Overlay, Modal, Form, Popover } from "react-bootstrap";
import { Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { logout } from "../utils/auth";
import { Redirect } from "react-router-dom";
import Scrollbar from "react-scrollbars-custom";
import { setLoadingPage, setErrorMessage, setTimezoneId, setRealtimeGroupId, setRealtimeGroupName, setReportAssetId, setReportCalendatDate, setReportAssetName, setReportGroupId } from "../reducers/actions";
import { connect } from "react-redux";
import axios from "axios";
import TimeAgo from "timeago-react";
import { utcToDate } from "../utils/dateConvert";
import { apiHost } from "../api/apiClient";
import notification from "../Assets/notification.mp3";
import visionTrakLogo from "../Assets/visiontrak-logo-colored.png";
import { LinkContainer } from "react-router-bootstrap";
import $ from "jquery";
import signalRHelper from "../utils/signalRHelper";
import AlertEventIcon from "../components/common/alertEventIcon";

import RecentIncidents from "./recentIncidents";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recentIncidents: null,
      recentIncidentsFailed: false,
      recentIncidentsLoading: false,
      role: localStorage.getItem("role"),
      redirect: false,
      popOverDuress: false,
      target: "",
      popOverBehaviour: false,
      targetBehaviour: "",
      popOverNotification: false,
      targetNotification: "",
      alertsDuressList: [],
      alertsBehaviourList: [],
      alertsNotificationList: [],
      duressTotal: 0,
      behaviourTotal: 0,
      notificationTotal: 0,
      pendingDuress: 0,
      pendingBehaviour: 0,
      pendingNotification: 0,
      //states for modal
      modalShow: false,
      modalEvent: "",
      modalAsset: "",
      modalCreated: "",
      modalDifference: "",
      modalAddress: "",
      modalCutomerName: "",
      acknowledgementDescription: "",
      modalUserId: "",
      modalUserName: "",
      ackDesc: "",
      modalAcknowledgeTime: "",
      duressRedirect: false,
      behaviourRedirect: false,
      notificationRedirect: false,
      timeZoneName: "",
      timeZones: [],
      customGroups: false,
      bellIconClick: false,
      helpCentreVisible: localStorage.getItem("role") === "SystemAdmin",
      systemVersion: "v3.0.4",
      limitedLoginUserCount: 0,
    };
    this.textInput = React.createRef();
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  async componentDidMount() {
    this.headerMounted = true;
    window.addEventListener("driver-incidents-changed", this.handleIncidentChange);
    window.addEventListener("storage", this.handleIncidentChange);
    if (window.location.pathname == "/realTime") {
      this.setState({ customGroups: true });
    }

    if (localStorage.getItem("token") !== null) {
      this.getAlerts();
      this.loadRecentIncidents();
      this.loadHelpCentreVisibility();
      this.loadSystemVersion();
      if (localStorage.getItem("role") === "SystemAdmin") {
        this.loadLoginLimitSummary();
        this.loginLimitInterval = window.setInterval(this.loadLoginLimitSummary, 60 * 1000);
        window.addEventListener("login-limits-changed", this.loadLoginLimitSummary);
      }
      this.alertExpiryInterval = window.setInterval(this.refreshNavbarAlerts, 60 * 1000);
    }

    // Attach to signalR
    this.handleSignalR();
  }

  loadHelpCentreVisibility = async () => {
    try {
      const response = await axios.get(`${apiHost}/api/HelpCentre/Visibility`, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      });
      this.setState({ helpCentreVisible: response.data && response.data.canView === true });
    } catch (error) {
      this.setState({ helpCentreVisible: localStorage.getItem("role") === "SystemAdmin" });
    }
  };

  loadSystemVersion = async () => {
    try {
      const response = await axios.get(`${apiHost}/api/SystemVersion`, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      });
      this.setState({ systemVersion: response.data?.version || "v3.0.4" });
    } catch (error) {
      this.setState({ systemVersion: "v3.0.4" });
    }
  };

  loadLoginLimitSummary = async () => {
    try {
      const response = await axios.get(`${apiHost}/api/auth/LoginLimitsSummary`, {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      });
      this.setState({ limitedLoginUserCount: response.data?.limitedUserCount || 0 });
    } catch (error) {
      this.setState({ limitedLoginUserCount: 0 });
    }
  };

  releaseSignalR() {
    if (!this.connection) {
      return;
    }
    // Release signalR handlers
    signalRHelper.unsubscribe("Duress");
    signalRHelper.unsubscribe("Behaviour");
    signalRHelper.unsubscribe("Notification");

    this.connection.off("Duress");
    this.connection.off("Behaviour");
    this.connection.off("Notification");
    this.connection = null;
  }

  setCustomGroup = () => {
    this.setState({ customGroups: true });
  };

  removeCustomGroup = () => {
    this.setState({ customGroups: false });
  };

  getRoleBadgeLabel = () => {
    const role = this.state.role || localStorage.getItem("role") || "User";
    const labels = {
      CommunityManager: "Community Manager",
      "Community Manager": "Community Manager",
      VTDemo: "VtDemo",
      VtDemo: "VtDemo",
      SystemAdmin: "SystemAdmin",
      User: "User",
    };

    return labels[role] || role;
  };

  getRoleBadgeClass = () => {
    const role = this.state.role || localStorage.getItem("role") || "User";
    const normalisedRole = role.toString().toLowerCase().replace(/\s+/g, "");
    const classMap = {
      systemadmin: "systemadmin",
      communitymanager: "communitymanager",
      user: "user",
      vtdemo: "vtdemo",
    };

    return classMap[normalisedRole] || "default";
  };

  getAlerts = async () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const assetId = urlParams.get("assetId");
    const assetName = urlParams.get("assetName");
    const assetDate = urlParams.get("assetDate") || urlParams.get("SearchDate") || urlParams.get("searchDate");
    const groupId = urlParams.get("groupId") || urlParams.get("GroupId");

    setTimeout(() => {
      if (urlParams.get("assetId")) {
        this.props.setReportAssetIdAction(assetId);
        this.props.setReportAssetNameAction(assetName);
        this.props.setReportCalendatDateAction(assetDate);
        this.props.setReportGroupIdAction(groupId || "");
      }
    }, 1000);

    try {
      let timezone = await axios.get(`${apiHost}/api/Customer/GetAllTimeZone`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      this.setState({
        timeZones: timezone.data,
        timeZoneName: timezone.data[0].timeZoneCity,
      });
      if (localStorage.getItem("timeZone") == null) {
        localStorage.setItem("timeZone", timezone.data[0].timeZoneCity);
        localStorage.setItem("timeZoneID", timezone.data[0].timeZonesId);
      }
      this.props.setTimezoneIdAction(timezone.data[0].timeZonesId);
    } catch (e) {
      console.log(`😱 Axios request failed: ${e}`);
    }
    document.addEventListener("mousedown", this.handleClickOutside);

    this.handleDuressAndBehaviourCall();
    this.handleNotificationCall();
  };

  handleDuressAndBehaviourCall = async () => {
    try {
      let alertsList = await axios.get(`${apiHost}/api/Event/GetLatestEventsWithCount`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      const duressAlerts = this.filterAlertsToLast24Hours(alertsList.data.Duress);
      const behaviourAlerts = this.filterAlertsToLast24Hours(alertsList.data.Behavior);
      this.setState({
        alertsDuressList: duressAlerts,
        alertsBehaviourList: behaviourAlerts,
        TotalBehavior: alertsList.data.TotalBehavior,
        TotalDuress: alertsList.data.TotalDuress,
        pendingDuress: Number(alertsList.data.PendingDuress) || 0,
        duressTotal: Number(alertsList.data.TotalDuress) || 0,
        pendingBehaviour: Number(alertsList.data.PendingBehavior) || 0,
        behaviourTotal: Number(alertsList.data.TotalBehavior) || 0,
      });
    } catch (e) {
      this.props.setErrorMessageAction(`${e}`);
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleNotificationCall = async () => {
    try {
      let notification = await axios.get(`${apiHost}/api/Notification/LatestNotificationWithCount`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      const notifications = this.filterAlertsToLast24Hours(notification.data.Notifications);
      const notificationCount = Number(notification.data.NotificationsCount) || 0;
      this.setState({
        alertsNotificationList: notifications,
        notificationCount: notificationCount,
        notificationTotal: notifications.length,
        pendingNotification: notificationCount,
      });
    } catch (e) {
      this.props.setErrorMessageAction(`${e}`);
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  changeTimeZone = (timezone, timezoneCityID) => {
    this.props.setTimezoneIdAction(timezone);
    this.setState({ timeZoneName: timezoneCityID });
    localStorage.setItem("timeZoneID", timezone);
    localStorage.setItem("timeZone", timezoneCityID);

    window.location.reload(false);
  };

  async handleSignalR() {
    this.connection = await signalRHelper.getConnection();
    this.addAlerts();
  }

  addAlerts = () => {
    signalRHelper.subscribe("Duress");
    signalRHelper.subscribe("Behaviour");
    signalRHelper.subscribe("Notification");

    this.connection.on("Duress", (data) => {
      this.data = data;
      this.handleDuressAndBehaviourCall();
    });

    this.connection.on("Behaviour", (data) => {
      this.data = data;
      this.handleDuressAndBehaviourCall();
    });

    this.connection.on("Notification", (data) => {
      this.data = data;
      if (data && data.liveDepotAlert) {
        this.createNotificationList(data);
      } else {
        this.handleNotificationCall();
      }
    });
  };
  createNotificationList = (data) => {
    let counter = 0;
    let currentList = [...this.state.alertsNotificationList];
    currentList.forEach((item, index) => {
      if (item.id == data.id) {
        currentList[index] = data;
        counter++;
      }
    });

    if (counter == 0) {
      currentList.push(data);
      this.playAudio();
    }

    currentList.sort(function (x, y) {
      var date1 = new Date(x.gPRMC.created);
      var date2 = new Date(y.gPRMC.created);
      return date2 - date1;
    });

    this.setState({
      alertsNotificationList: currentList,
    }, this.notificationPendingAlertCalculation);
  };

  notificationPendingAlertCalculation = () => {
    let total = 0;
    if (this.state.alertsNotificationList !== "") {
      this.state.alertsNotificationList.forEach((item, index) => {
        total++;
      });
    }

    let countnot = this.state.notificationCount;
    this.setState({
      notificationTotal: total,
      pendingNotification: countnot,
    });
  };

  handleIncidentChange = event => {
    if (event.type === "storage" && event.key !== "driver-incidents-changed") return;
    if (this.incidentsRequestPending) this.incidentsRefreshQueued = true;
    else this.loadRecentIncidents();
  };

  loadRecentIncidents = async (more = false) => {
    if (this.incidentsRequestPending || !localStorage.getItem("token") || document.hidden) return;
    this.incidentsRequestPending = true;
    const token = localStorage.getItem("token");
    const previous = this.state.recentIncidents;
    const offset = more && previous ? previous.items.length : 0;
    this.setState({ recentIncidentsLoading: true });
    try {
      const response = await axios.get(`${apiHost}/api/Assets/RecentDriverIncidents?offset=${offset}`, {
        headers: { Authorization: "Bearer " + token }, timeout: 20000,
      });
      if (!this.headerMounted || token !== localStorage.getItem("token")) return;
      const data = response.data;
      if (!data || !Array.isArray(data.items) || typeof data.total !== "number") {
        const error = new Error("Invalid incident summary response");
        error.code = typeof data === "string" && /<!doctype html|<html/i.test(data)
          ? "INCIDENT_API_RETURNED_HTML" : "INVALID_INCIDENT_RESPONSE";
        error.response = { status: response.status, headers: response.headers };
        throw error;
      }
      const items = offset ? [...previous.items, ...data.items].filter((item, index, all) => all.findIndex(other => other.incidentId === item.incidentId) === index) : data.items;
      this.setState({ recentIncidents: { ...data, items }, recentIncidentsFailed: false });
    } catch (error) {
      if (this.headerMounted && token === localStorage.getItem("token")) {
        if (!this.state.recentIncidentsFailed) console.warn("Recent incident summary refresh failed", {
          status: error.response?.status, code: error.code || "NETWORK_ERROR",
          contentType: error.response?.headers?.["content-type"],
          message: error.message,
        });
        this.setState({ recentIncidentsFailed: true });
      }
    } finally {
      this.incidentsRequestPending = false;
      if (this.headerMounted) {
        this.setState({ recentIncidentsLoading: false });
        if (this.incidentsRefreshQueued) {
          this.incidentsRefreshQueued = false;
          this.loadRecentIncidents();
        }
      }
    }
  };

  refreshNavbarAlerts = () => {
    this.loadRecentIncidents();
    this.handleNotificationCall();
    this.handleDuressAndBehaviourCall();
  };

  componentWillUnmount() {
    this.headerMounted = false;
    window.removeEventListener("driver-incidents-changed", this.handleIncidentChange);
    window.removeEventListener("storage", this.handleIncidentChange);
    document.removeEventListener("mousedown", this.handleClickOutside);
    window.clearInterval(this.alertExpiryInterval);
    window.clearInterval(this.loginLimitInterval);
    window.removeEventListener("login-limits-changed", this.loadLoginLimitSummary);
    this.releaseSignalR();
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(event) {
    if ($("#popover-contained") != null && event.target.closest('div[id^="popover-contained"]') == null) {
      this.setState({
        popOverDuress: false,
        popOverBehaviour: false,
        popOverNotification: false,
      });
    }
  }

  handleLogOut = () => {
    logout();
  };

  handleOpenBuoy = (event) => {
    const isOpening = !this.state.popOverDuress;
    this.setState({
      popOverDuress: isOpening,
      target: event.target,
      bellIconClick: true,
    });
    if (isOpening) {
      this.handleDuressAndBehaviourCall();
    }
  };

  handleOpenBell = (event) => {
    const isOpening = !this.state.popOverNotification;
    this.setState({
      popOverNotification: isOpening,
      targetNotification: event.target,
      bellIconClick: false,
    });
    if (isOpening) {
      this.handleNotificationCall();
    }
  };

  handleOpenExclamation = (event) => {
    const isOpening = !this.state.popOverBehaviour;
    this.setState({
      popOverBehaviour: isOpening,
      targetBehaviour: event.target,
      bellIconClick: true,
    });
    if (isOpening) {
      this.handleDuressAndBehaviourCall();
    }
  };

  handleClose = () => {
    this.setState({
      modalShow: false,
    });
  };

  handleShow = (event, asset, created, difference, address, customer, id) => {
    this.setState({
      modalUserId: "",
      ackDesc: "",
      modalShow: true,
      modalId: id,
      modalEvent: event,
      modalAsset: asset,
      modalCutomerName: customer,
      modalAddress: address,
      modalCreated: created,
      modalDifference: difference,
    });
  };

  handleDuressViewall = () => {
    this.setState({
      duressRedirect: true,
    });
  };

  handleBehaviourViewall = () => {
    this.setState({
      behaviourRedirect: true,
    });
  };

  handleNotificationViewall = () => {
    this.setState({
      notificationRedirect: true,
    });
  };

  handleAcknowledegmentDescription = (e) => {
    this.setState({
      acknowledgementDescription: e.target.value,
    });
  };

  handleAcknowledged = (event, asset, created, difference, address, customer, id, userId, ackMsg, usrname, ackTime) => {
    this.setState({
      modalShow: true,
      modalId: id,
      modalEvent: event,
      modalAsset: asset,
      modalCutomerName: customer,
      modalAddress: address,
      modalCreated: created,
      modalDifference: difference,
      modalUserId: userId,
      ackDesc: ackMsg,
      modalUserName: usrname,
      modalAcknowledgeTime: ackTime,
    });
  };

  handleAcknowledge = async (id, description) => {
    let url;
    if (this.state.bellIconClick) {
      url = `${apiHost}/api/Event/EventAcknowledgement`;
    } else {
      url = `${apiHost}/api/Notification/NotificationAcknowledgement`;
    }
    this.props.setLoadingPageAction(true);

    try {
      if (this.state.bellIconClick) {
        await axios.post(
          url,
          {
            MessageId: id,
            Acknowledgement: description,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
      } else {
        await axios.post(
          url,
          {
            MessageId: id,
            Acknowledgement: description,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
      }
      this.setState({
        modalShow: false,
      });
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  playAudio = () => {
    var x = document.getElementById("myAudio");
    if (x) {
      x.play();
    }
  };

  getAlertTimestamp = (alert) => {
    if (!alert) {
      return null;
    }

    return alert.gPRMC?.created || alert.created || alert.received || alert.lastReported;
  };

  filterAlertsToLast24Hours = (alerts) => {
    if (!Array.isArray(alerts)) {
      return [];
    }

    const cutoff = Date.now() - (24 * 60 * 60 * 1000);
    return alerts.filter(alert => {
      const timestamp = this.getAlertTimestamp(alert);
      const eventTime = timestamp ? new Date(timestamp).getTime() : NaN;
      return !Number.isNaN(eventTime) && eventTime >= cutoff && eventTime <= Date.now();
    });
  };

  formatCompactAlertAge = (timestamp) => {
    if (!timestamp) {
      return "New";
    }

    const eventDate = new Date(timestamp);
    if (Number.isNaN(eventDate.getTime())) {
      return "New";
    }

    const seconds = Math.max(0, Math.floor((Date.now() - eventDate.getTime()) / 1000));
    if (seconds < 60) {
      return `${seconds || 1} sec`;
    }

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) {
      return `${minutes} min`;
    }

    const hours = Math.floor(minutes / 60);
    if (hours < 24) {
      return `${hours} hr`;
    }

    return `${Math.floor(hours / 24)} d`;
  };

  renderAlertAgeBadge = (alert) => {
    const timestamp = this.getAlertTimestamp(alert);

    return (
      <Badge className="notificationAgeBadge">
        {this.formatCompactAlertAge(timestamp)}
      </Badge>
    );
  };

  handleGroupSelection = (id, name) => {
    this.props.setRealtimeGroupIdAction(id);
    this.props.setRealtimeGroupNameAction(name);
    localStorage.setItem("realTimeGroupId", id);
    localStorage.setItem("realTimeGroupName", name);
  };

  render() {
    if (this.state.duressRedirect === true) {
      this.setState({
        duressRedirect: false,
        popOverDuress: false,
        popOverBehaviour: false,
        popOverNotification: false,
      });
      return <Redirect to="/AlertCentre?alert=duress" />;
    }
    if (this.state.behaviourRedirect === true) {
      this.setState({
        behaviourRedirect: false,
        popOverDuress: false,
        popOverBehaviour: false,
        popOverNotification: false,
      });
      return <Redirect to="/AlertCentre?alert=behaviour" />;
    }
    if (this.state.notificationRedirect === true) {
      this.setState({
        notificationRedirect: false,
        popOverNotification: false,
        popOverDuress: false,
        popOverBehaviour: false,
      });
      return <Redirect to="/AlertNotification" />;
    }
    const accountUserName = localStorage.getItem("accountDisplayName") || localStorage.getItem("userName") || "User";
    const accountEmail = localStorage.getItem("accountEmail") || localStorage.getItem("userName") || "-";
    const accountUserId = localStorage.getItem("userId") || "-";

    let values = null;
    try {
      values = JSON.parse(localStorage.getItem("customer"));
    } catch (e) {
      values = null;
    }
    let customerName = "";
    let customerId = "";
    if (values) {
      customerName = values.customerName;
      customerId = values.customerId;
    }
    const customerPath = (path) => customerId
      ? `${path}?customerId=${encodeURIComponent(customerId)}&customerName=${encodeURIComponent(customerName || "")}`
      : path;

    const normalizedRole = (this.state.role || localStorage.getItem("role") || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "");
    const isSystemAdmin = normalizedRole == "systemadmin";
    const isCommunityManager = normalizedRole == "communitymanager";
    const isVtDemo = normalizedRole == "vtdemo";

    return (
      <div className="responsiveLoginNavBar ">
        <div className="loginContainer">
          <Navbar collapseOnSelect expand="lg" variant="light" className="assettrakNavbar">
            <LinkContainer to="/home">
              <Navbar.Brand className="assettrakBrand">
                <img src={visionTrakLogo} alt="VisionTrak" />
                <span className="assettrakVersion">V3</span>
              </Navbar.Brand>
            </LinkContainer>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="mr-auto">
                {isSystemAdmin && (
                  <NavDropdown
                    title="Admin"
                    id="admin-nav-dropdown"
                    className="adminNavPill"
                    onToggle={(isOpen) => isOpen && this.loadLoginLimitSummary()}
                  >
                    <LinkContainer onClick={this.removeCustomGroup} to="/admin/login-limits">
                      <NavDropdown.Item className="adminLoginLimitsItem">
                        <span>Login Limits</span>
                        {this.state.limitedLoginUserCount > 0 && (
                          <span className="adminLoginLimitsBadge">{this.state.limitedLoginUserCount}</span>
                        )}
                      </NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer onClick={this.removeCustomGroup} to="/video-retrievals">
                      <NavDropdown.Item>Retrieved recordings</NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer onClick={this.removeCustomGroup} to="/Rpt-VideoUsage">
                      <NavDropdown.Item>Video Usage</NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer onClick={this.removeCustomGroup} to="/page-visits">
                      <NavDropdown.Item>Page Visits</NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer onClick={this.removeCustomGroup} to="/page-visits-heat-map">
                      <NavDropdown.Item>Page Visits Heat Map</NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer onClick={this.removeCustomGroup} to="/raw-message-diagnostics">
                      <NavDropdown.Item>Raw Message Diagnostics</NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer onClick={this.removeCustomGroup} to="/news-admin">
                      <NavDropdown.Item>Broadcast NEWS</NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer onClick={this.removeCustomGroup} to="/asset-log-report">
                      <NavDropdown.Item>Asset Log</NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer onClick={this.removeCustomGroup} to="/maintenance-subscribers">
                      <NavDropdown.Item>Maintenance Subscribers</NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/erp-asset-mappings")}>
                      <NavDropdown.Item>ERP Asset Mappings</NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer onClick={this.removeCustomGroup} to="/help-centre/admin">
                      <NavDropdown.Item>Manage Help Centre</NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/checklist-management")}>
                      <NavDropdown.Item>Checklist Management</NavDropdown.Item>
                    </LinkContainer>
                  </NavDropdown>
                )}
                <LinkContainer onClick={this.removeCustomGroup} to="/news">
                  <Nav.Link>News</Nav.Link>
                </LinkContainer>
                <LinkContainer onClick={this.removeCustomGroup} to="/home">
                  <Nav.Link>Dashboard</Nav.Link>
                </LinkContainer>
                <LinkContainer onClick={this.setCustomGroup} to="/realTime">
                  <Nav.Link>Realtime</Nav.Link>
                </LinkContainer>
                <NavDropdown title="Reports" id="reports-nav-dropdown" className="wideNavDropdown">
                  <NavDropdown.Item href="/Rpt-MVTL">MV Trip Log</NavDropdown.Item>
                  <NavDropdown.Item href="/Rpt-Visit">Visit</NavDropdown.Item>

                  <NavDropdown.Item href="/Temperature">Temperature</NavDropdown.Item>
                  <NavDropdown.Item href="/Rpt-LocationData">Location Data</NavDropdown.Item>
                  <NavDropdown.Item href="/Timeline">Timeline</NavDropdown.Item>
                  <NavDropdown.Item href="/Track">Track</NavDropdown.Item>
                  <NavDropdown.Item href="/Replay">Replay</NavDropdown.Item>
                  <NavDropdown.Divider />

                  <NavDropdown.Item href="/MultiVisit">Multi-Asset Visit</NavDropdown.Item>
                  <NavDropdown.Item href="/Driver-Logs">Driver Logs</NavDropdown.Item>

                  <NavDropdown.Item href="/Rpt-summary"> Asset Summary</NavDropdown.Item>

                  <NavDropdown.Item href="/Rpt-Group-Summary"> Group Summary</NavDropdown.Item>

                  <NavDropdown.Item href="/Rpt-PointOfInterest">POI Zone Visits</NavDropdown.Item>

                  <NavDropdown.Item href="/Rpt-Geofence">POI Zone Entry/Exit</NavDropdown.Item>

                  <NavDropdown.Item href="/RunSheet-Dispatch-Summary">Run Sheet Summary</NavDropdown.Item>

                  <NavDropdown.Item href="/Rpt-RunSheets">Run Sheets</NavDropdown.Item>

                  <NavDropdown.Item href="/Rpt-IButton"> IButton Report</NavDropdown.Item>

                </NavDropdown>
                
                <NavDropdown title="Manage" id="manage-nav-dropdown" className="wideNavDropdown">
                  {isSystemAdmin ? (
                    <>
                      <LinkContainer onClick={this.removeCustomGroup} to="/customers">
                        <NavDropdown.Item>Customer</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerPath("/groups")}
                      >
                        <NavDropdown.Item>Groups</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerPath("/assets")}
                      >
                        <NavDropdown.Item>Assets</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/non-tracked-assets")}>
                        <NavDropdown.Item>Non-tracked Assets</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/maintenance-due")}>
                        <NavDropdown.Item>Maintenance Due</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerPath("/devices")}
                      >
                        <NavDropdown.Item>Devices</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerPath("/users")}
                      >
                        <NavDropdown.Item>Users</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerPath("/drivers")}
                      >
                        <NavDropdown.Item>Drivers</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerPath("/notifications")}
                      >
                        <NavDropdown.Item>Notifications</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerPath("/depots")}
                      >
                        <NavDropdown.Item>Depots</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerPath("/zones")}
                      >
                        <NavDropdown.Item>POI Zones</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/checklist-notifications")}>
                        <NavDropdown.Item>Checklist Notifications</NavDropdown.Item>
                      </LinkContainer>
                      <NavDropdown.Divider />
                      <LinkContainer onClick={this.removeCustomGroup} to="/events">
                        <NavDropdown.Item>Events</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to="/ibutton">
                        <NavDropdown.Item>iButtons</NavDropdown.Item>
                      </LinkContainer>
                    </>
                  ) : isCommunityManager ? (
                    <>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerPath("/assets")}
                      >
                        <NavDropdown.Item>Assets</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/non-tracked-assets")}>
                        <NavDropdown.Item>Non-tracked Assets</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/maintenance-due")}>
                        <NavDropdown.Item>Maintenance Due</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerPath("/users")}
                      >
                        <NavDropdown.Item>Users</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/drivers")}>
                        <NavDropdown.Item>Drivers</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerPath("/zones")}
                      >
                        <NavDropdown.Item>POI Zones</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/checklist-notifications")}>
                        <NavDropdown.Item>Checklist Notifications</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/notifications")}>
                        <NavDropdown.Item>Notifications</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/depots")}>
                        <NavDropdown.Item>Depots</NavDropdown.Item>
                      </LinkContainer>
                    </>
                  ) : isVtDemo ? (
                    <>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerPath("/assets")}
                      >
                        <NavDropdown.Item>Assets</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/non-tracked-assets")}>
                        <NavDropdown.Item>Non-tracked Assets</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/maintenance-due")}>
                        <NavDropdown.Item>Maintenance Due</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerPath("/users")}
                      >
                        <NavDropdown.Item>Users</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/drivers")}>
                        <NavDropdown.Item>Drivers</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerPath("/zones")}
                      >
                        <NavDropdown.Item>POI Zones</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/checklist-notifications")}>
                        <NavDropdown.Item>Checklist Notifications</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/notifications")}>
                        <NavDropdown.Item>Notifications</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/depots")}>
                        <NavDropdown.Item>Depots</NavDropdown.Item>
                      </LinkContainer>
                    </>
                  ) : (
                    <React.Fragment>
                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerPath("/assets")}
                      >
                        <NavDropdown.Item>Assets</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/non-tracked-assets")}>
                        <NavDropdown.Item>Non-tracked Assets</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/maintenance-due")}>
                        <NavDropdown.Item>Maintenance Due</NavDropdown.Item>
                      </LinkContainer>

                      <LinkContainer
                        onClick={this.removeCustomGroup}
                        to={customerPath("/zones")}
                      >
                        <NavDropdown.Item>POI Zones</NavDropdown.Item>
                      </LinkContainer>
                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/checklist-notifications")}>
                        <NavDropdown.Item>Checklist Notifications</NavDropdown.Item>
                      </LinkContainer>

                      <LinkContainer onClick={this.removeCustomGroup} to={customerPath("/notifications")}>
                        <NavDropdown.Item>Notifications</NavDropdown.Item>
                      </LinkContainer>
                    </React.Fragment>
                  )}
                </NavDropdown>

                {isVtDemo || isCommunityManager ? (
                  <NavDropdown title="Visioncam" id="visioncam-nav-dropdown">
                    <LinkContainer onClick={this.removeCustomGroup} to="/video-retrievals">
                      <NavDropdown.Item>Retrieved recordings</NavDropdown.Item>
                    </LinkContainer>
                    <LinkContainer onClick={this.removeCustomGroup} to="/Rpt-VideoUsage">
                      <NavDropdown.Item>Video Usage</NavDropdown.Item>
                    </LinkContainer>
                  </NavDropdown>
                ) : (
                  <LinkContainer onClick={this.removeCustomGroup} to="/visioncam">
                    <Nav.Link>Visioncam</Nav.Link>
                  </LinkContainer>
                )}
                <LinkContainer onClick={this.removeCustomGroup} to="/apps">
                  <Nav.Link>Apps</Nav.Link>
                </LinkContainer>
                {this.state.helpCentreVisible && (
                  <LinkContainer onClick={this.removeCustomGroup} to="/help-centre">
                    <Nav.Link>Help</Nav.Link>
                  </LinkContainer>
                )}
              </Nav>
              <Nav className="rightMenu align-items-lg-center">
                <span className={`vt-role-badge vt-role-badge-${this.getRoleBadgeClass()}`}>
                  {this.getRoleBadgeLabel()}
                </span>
                <div className="realtimeDropdown">
                  <NavDropdown id="dropdown-item-timezone" className="timezoneDropdown" title={localStorage.getItem("timeZone")}>
                    <div
                      style={{
                        maxHeight: "60vh",
                        overflowY: "scroll",
                      }}
                    >
                      {this.state.timeZones.map((item, index) => {
                        return (
                          <NavDropdown.Item
                            key={index}
                            as="button"
                            onClick={() => this.changeTimeZone(item.timeZonesId, item.timeZoneCity)}
                            value="act"
                          >
                            {item.timeZoneCity}
                          </NavDropdown.Item>
                        );
                      })}
                    </div>
                  </NavDropdown>
                </div>
                <RecentIncidents data={this.state.recentIncidents} failed={this.state.recentIncidentsFailed}
                  loading={this.state.recentIncidentsLoading}
                  onMore={() => this.loadRecentIncidents(true)} />
                <Nav.Link>
                  <div>
                    <div className={`notificationContainer notificationTrigger notification-general ${Number(this.state.pendingNotification) > 0 ? "has-pending" : "no-pending"}`} onClick={this.handleOpenBell}>
                      <i className="fa fa-bell-o" size="lg" />
                      {Number(this.state.pendingNotification) > 0 && <button className="notificationBadge notificationBadgeMinimal">{this.state.pendingNotification}</button>}
                    </div>
                    <div className="notificationPopup">
                      <Overlay show={this.state.popOverNotification} target={this.state.targetNotification} placement="bottom" containerPadding={20}>
                        <Popover bsPrefix="popover" id="popover-contained" className="headerNotificationPopover general">
                          <Popover.Header as="h3">
                            <div className="popoverGroupTitle">
                              <div>
                                <span>Notifications</span>
                                <h3>
                                  <strong>{this.state.pendingNotification}</strong> Pending Alerts
                                </h3>
                              </div>
                              <button type="button" onClick={this.handleNotificationViewall}>View all</button>
                            </div>
                          </Popover.Header>
                          <Popover.Body>
                            <Scrollbar
                              noScrollX
                              style={{
                                width: 420,
                                height: 360,
                              }}
                            >
                              {this.state.alertsNotificationList
                                ? this.state.alertsNotificationList.map((item, index) => {
                                    if (index < 30) {
                                      return (
                                        <ul className="popOverContents headerNotificationList" key={item.id || index}>
                                          <li className={item.userId ? "notificationRowAcknowledged" : ""}>
                                            <span className="left">
                                              <AlertEventIcon event={item} className="notificationItemIcon" />
                                              <span className="notificationItemText">
                                                <strong>{item.assetName}</strong>
                                                <small>{item.eventName}{item.uniqueId ? ` - [${item.uniqueId}]` : ""}</small>
                                              </span>
                                                <i
                                                className="fa fa-info-circle text-primary notificationInfoHint"
                                                title={`Notification: ${item.eventName} - [${item.uniqueId}]`}
                                              ></i>
                                            </span>
                                            <div className="right">
                                              <div className="leftRight">
                                                {item.userId ? (
                                                  <button
                                                    className="notificationActionButton info"
                                                    onClick={() => {
                                                      this.setState({
                                                        bellIconClick: true,
                                                      });
                                                      this.handleAcknowledged(
                                                        item.eventName,
                                                        item.assetName,
                                                        item.created,
                                                        item.difference,
                                                        item.location,
                                                        item.customerName,
                                                        item.id,
                                                        item.userId,
                                                        item.acknowledgedDescription,
                                                        item.userName,
                                                        item.acknowledgeTime
                                                      );
                                                    }}
                                                  >
                                                    <i className="fa fa-info" />
                                                  </button>
                                                ) : (
                                                  <button
                                                    className="notificationActionButton"
                                                    variant="danger"
                                                    onClick={() =>
                                                      this.handleShow(
                                                        item.eventName,
                                                        item.assetName,
                                                        item.created,
                                                        item.difference,
                                                        item.location,
                                                        item.customerName,
                                                        item.id
                                                      )
                                                    }
                                                    size="sm"
                                                  >
                                                    <i className="fa fa-check" />
                                                  </button>
                                                )}
                                              </div>

                                              <div className="rightRight">
                                                {this.renderAlertAgeBadge(item)}
                                              </div>
                                            </div>
                                          </li>
                                        </ul>
                                      );
                                    }

                                    return null;
                                  })
                                : ""}
                            </Scrollbar>
                          </Popover.Body>
                        </Popover>
                      </Overlay>
                    </div>
                  </div>
                </Nav.Link>
                <Nav.Link>
                  <div>
                    <div className={`notificationContainer notificationTrigger notification-duress ${Number(this.state.pendingDuress) > 0 ? "has-pending" : "no-pending"}`} onClick={this.handleOpenBuoy}>
                      <i className="fa fa-life-buoy" size="lg" />
                      {Number(this.state.pendingDuress) > 0 && <button className="notificationBadgeFlicker">{this.state.pendingDuress}</button>}
                    </div>
                    <div className="notificationPopup">
                      <Overlay show={this.state.popOverDuress} target={this.state.target} placement="bottom" containerPadding={20}>
                        <Popover bsPrefix="popover" id="popover-contained" ref={this.textInput} className="headerNotificationPopover duress">
                          <Popover.Header as="h3">
                            <div className="popoverGroupTitle">
                              <div>
                                <span>Duress</span>
                                <h3>
                                  <strong>{this.state.pendingDuress}</strong> Pending Alerts
                                </h3>
                              </div>
                              <button type="button" onClick={this.handleDuressViewall}>View all</button>
                            </div>
                          </Popover.Header>
                          <Popover.Body>
                            <Scrollbar
                              noScrollX
                              style={{
                                width: 420,
                                height: 360,
                              }}
                            >
                              {this.state.alertsDuressList
                                ? this.state.alertsDuressList.map((item, index) => {
                                    if (index < 30) {
                                      return (
                                        <ul className="popOverContents headerNotificationList" key={item.id || index}>
                                          <li className={item.userId ? "notificationRowAcknowledged" : ""}>
                                            <span className="left">
                                              <AlertEventIcon event={item} className="notificationItemIcon" />
                                              <span className="notificationItemText">
                                                <strong>{item.assetName}</strong>
                                                <small>{item.eventName || "Duress"}</small>
                                              </span>
                                            </span>
                                            <div className="right">
                                              <div className="leftRight">
                                                {item.userId ? (
                                                  <button
                                                    className="notificationActionButton info"
                                                    onClick={() => {
                                                      this.setState({
                                                        bellIconClick: false,
                                                      });
                                                      this.handleAcknowledged(
                                                        item.eventName,
                                                        item.assetName,
                                                        item.created,
                                                        item.difference,
                                                        item.location,
                                                        item.customerName,
                                                        item.id,
                                                        item.userId,
                                                        item.acknowledgedDescription,
                                                        item.userName,
                                                        item.acknowledgeTime
                                                      );
                                                    }}
                                                  >
                                                    <i className="fa fa-info" />
                                                  </button>
                                                ) : (
                                                  <button
                                                    className="notificationActionButton"
                                                    variant="danger"
                                                    onClick={() =>
                                                      this.handleShow(
                                                        item.eventName,
                                                        item.assetName,
                                                        item.created,
                                                        item.difference,
                                                        item.location,
                                                        item.customerName,
                                                        item.id
                                                      )
                                                    }
                                                    size="sm"
                                                  >
                                                    <i className="fa fa-check" />
                                                  </button>
                                                )}
                                              </div>

                                              <div className="rightRight">
                                                {this.renderAlertAgeBadge(item)}
                                              </div>
                                            </div>
                                          </li>
                                        </ul>
                                      );
                                    }

                                    return null;
                                  })
                                : ""}
                            </Scrollbar>
                          </Popover.Body>
                        </Popover>
                      </Overlay>
                    </div>
                  </div>
                </Nav.Link>
                <audio id="myAudio">
                  <source src={notification} type="audio/mpeg" />
                </audio>

                <Nav.Link>
                  <div>
                    <div className={`notificationContainer notificationTrigger notification-behaviour ${Number(this.state.pendingBehaviour) > 0 ? "has-pending" : "no-pending"}`} onClick={this.handleOpenExclamation}>
                      <i className="fa fa-exclamation-triangle" size="lg" />
                      {Number(this.state.pendingBehaviour) > 0 && <button className="notificationBadge">{this.state.pendingBehaviour}</button>}
                    </div>
                    <div className="notificationPopup">
                      <Overlay show={this.state.popOverBehaviour} target={this.state.targetBehaviour} placement="bottom" containerPadding={20}>
                        <Popover bsPrefix="popover" id="popover-contained" className="headerNotificationPopover behaviour">
                          <Popover.Header as="h3">
                            <div className="popoverGroupTitle">
                              <div>
                                <span>Behaviour</span>
                                <h3>
                                  <strong>{this.state.pendingBehaviour}</strong> Pending Alerts
                                </h3>
                              </div>
                              <button type="button" onClick={this.handleBehaviourViewall}>View all</button>
                            </div>
                          </Popover.Header>
                          <Popover.Body>
                            <Scrollbar
                              noScrollX
                              style={{
                                width: 420,
                                height: 360,
                              }}
                            >
                              <ul className="popOverContents">
                                {this.state.alertsBehaviourList
                                  ? this.state.alertsBehaviourList.map((item, index) => {
                                      if (index < 30) {
                                        return (
                                          <ul className="popOverContents headerNotificationList" key={item.id || index}>
                                            <li className={item.userId ? "notificationRowAcknowledged" : ""}>
                                              <span className="left">
                                                <AlertEventIcon event={item} className="notificationItemIcon" />
                                                <span className="notificationItemText">
                                                  <strong>{item.assetName}</strong>
                                                  <small>{item.eventName || "Behaviour"}</small>
                                                </span>
                                              </span>
                                              <div className="right">
                                                <div className="leftRight">
                                                  {item.userId ? (
                                                    <button
                                                      className="notificationActionButton info"
                                                      onClick={() => {
                                                        this.setState({
                                                          bellIconClick: false,
                                                        });
                                                        this.handleAcknowledged(
                                                          item.eventName,
                                                          item.assetName,
                                                          item.created,
                                                          item.difference,
                                                          item.location,
                                                          item.customerName,
                                                          item.id,
                                                          item.userId,
                                                          item.acknowledgedDescription,
                                                          item.userName,
                                                          item.acknowledgeTime
                                                        );
                                                      }}
                                                    >
                                                      {" "}
                                                      <i className="fa fa-info" />
                                                    </button>
                                                  ) : (
                                                    <button
                                                      className="notificationActionButton"
                                                      variant="danger"
                                                      onClick={() =>
                                                        this.handleShow(
                                                          item.eventName,
                                                          item.assetName,
                                                          item.created,
                                                          item.difference,
                                                          item.location,
                                                          item.customerName,
                                                          item.id
                                                        )
                                                      }
                                                      size="sm"
                                                    >
                                                      <i className="fa fa-check" />
                                                    </button>
                                                  )}
                                                </div>

                                                <div className="rightRight">
                                                  {this.renderAlertAgeBadge(item)}
                                                </div>
                                              </div>
                                            </li>
                                          </ul>
                                        );
                                      }

                                      return null;
                                    })
                                  : ""}
                              </ul>
                            </Scrollbar>
                          </Popover.Body>
                        </Popover>
                      </Overlay>
                    </div>
                  </div>
                </Nav.Link>
                <NavDropdown
                  align="end"
                  className="accountDropdown"
                  id="account-nav-dropdown"
                  title={
                    <span className="accountDropdownTrigger" title="My profile">
                      <i className="fa fa-user-circle" aria-hidden="true"></i>
                      <span className="sr-only">My profile</span>
                    </span>
                  }
                >
                  <div className="accountDropdownProfileCard">
                    <div className="accountDropdownIdentity">
                      <span className="accountDropdownAvatar">
                        <i className="fa fa-user" aria-hidden="true"></i>
                      </span>
                      <div>
                        <span>Signed in as</span>
                        <strong>{accountUserName}</strong>
                      </div>
                    </div>
                    <div className="accountDropdownDetail">
                      <span>Email</span>
                      <strong title={accountEmail}>{accountEmail}</strong>
                    </div>
                    <div className="accountDropdownDetail accountDropdownUserId">
                      <span>User ID</span>
                      <strong title={accountUserId}>{accountUserId}</strong>
                    </div>
                    <div className="accountDropdownVersion"><i className="fa fa-code-fork" aria-hidden="true"></i><span>AssetTrak Build {this.state.systemVersion}</span></div>
                  </div>
                  <NavDropdown.Divider />
                  <LinkContainer to="/manageAccount">
                    <NavDropdown.Item>
                      <i className="fa fa-lock" aria-hidden="true"></i>
                      Change Password
                    </NavDropdown.Item>
                  </LinkContainer>
                  <NavDropdown.Divider />
                  <NavDropdown.Item as="button" className="accountDropdownLogout" onClick={() => this.handleLogOut()}>
                    <i className="fa fa-sign-out" aria-hidden="true"></i>
                    Log Out
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>
        <Modal show={this.state.modalShow} size="lg" onHide={this.handleClose} className="alertCentreModal headerAlertModal">
          <Modal.Header closeButton>
            <Modal.Title>{this.state.modalUserId == "" ? "Acknowledge alert" : <b>{this.state.modalEvent}</b>} </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={this.state.modalUserId == "" ? "alertModalSummary pending" : "alertModalSummary acknowledged"}>
              <span className="alertModalIcon">
                <i className={`fa ${this.state.modalUserId == "" ? "fa-exclamation" : "fa-check"}`} />
              </span>
              <div>
                <strong>{this.state.modalEvent}</strong>
                <p>{this.state.modalAsset}</p>
              </div>
            </div>
            <div className="alertModalDetails">
              <div>
                <span>Occurred</span>
                <strong>
                  {utcToDate(this.state.modalCreated)}
                  {this.state.modalDifference ? (
                    <small>
                      <TimeAgo datetime={this.state.modalDifference} />
                    </small>
                  ) : ""}
                </strong>
              </div>
              <div>
                <span>Customer</span>
                <strong>{this.state.modalCutomerName || "-"}</strong>
              </div>
              <div className="alertModalAddress">
                <span>Address</span>
                <strong>{this.state.modalAddress || "-"}</strong>
              </div>
            </div>
            {this.state.modalUserId !== "" && (
              <div className="alertModalAcknowledged">
                <span>Acknowledgement</span>
                <strong>{this.state.ackDesc || "No remarks recorded"}</strong>
                <small>
                  Acknowledged by {this.state.modalUserName} on {utcToDate(this.state.modalAcknowledgeTime)}
                </small>
              </div>
            )}
            {this.state.modalUserId == "" ? (
              <div className="alertModalRemarks">
                <label>Remarks</label>
                <Form>
                  <Form.Group controlId="exampleForm.ControlTextarea1">
                    <Form.Control
                      as="textarea"
                      onChange={this.handleAcknowledegmentDescription}
                      placeholder="Optional remarks about your acknowledgement"
                      rows="3"
                    />
                  </Form.Group>
                </Form>
                <div className="modalGraph">
                  <i className="fa fa-info-circle" />
                  <span>
                    By acknowledging this alert you are confirming it has occurred and that it no longer needs to be included in the alert centre notification area. Alerts over 24 hours old are automatically removed.
                  </span>
                </div>
              </div>
            ) : ""}
          </Modal.Body>
          <Modal.Footer>
            {this.state.modalUserId == "" ? (
              <div>
                <Button variant="success" size="sm" onClick={() => this.handleAcknowledge(this.state.modalId, this.state.acknowledgementDescription)}>
                  Acknowledge
                </Button>
                &nbsp;
                <Button variant="secondary" size="sm" onClick={this.handleClose}>
                  Cancel
                </Button>
              </div>
            ) : (
              <Button variant="outline-secondary" size="sm" onClick={this.handleClose}>
                Ok
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
  headerHide: state.headerHide,
  timeZoneId: state.timeZoneId,
  realTimeGroup: state.realTimeGroup,
  reportAssetId: state.reportAssetId,
  reportDate: state.reportDate,
  reportAssetName: state.reportAssetName,
  reportGroupId: state.reportGroupId,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
  setTimezoneIdAction: setTimezoneId,
  setRealtimeGroupIdAction: setRealtimeGroupId,
  setRealtimeGroupNameAction: setRealtimeGroupName,
  setReportAssetIdAction: setReportAssetId,
  setReportCalendatDateAction: setReportCalendatDate,
  setReportAssetNameAction: setReportAssetName,
  setReportGroupIdAction: setReportGroupId,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
